<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Task Management"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Activity Group</label>
                <AsyncSelect
                    placeholder="Select Activity"
                    v-model="activityGroup"
                    :additional-query="{type: 'group'}"
                    :api-service="fetchActivitySetupEndpoint"
                    label="name"
                />
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Organization Activity</label>
                <AsyncSelect
                    placeholder="Select Activity"
                    v-model="organizationActivity"
                    :api-service="fetchActivitySetupEndpoint"
                    label="name"
                />
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Client</label>
                <AsyncSelect
                    placeholder="Client"
                    v-model="client"
                    :api-service="fetchContactProfiles"
                    :additional-query="{roles: 'customer,lead'}"
                    label="name"
                />
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Project</label>
                <v-select
                    placeholder="Select Project"
                    v-model="project"
                    :options="projects"
                    label="name"
                />
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Task Role</label>
                <v-select
                    placeholder="Select Task Role"
                    :options="taskCalendarFilterList"
                    v-model="taskCalendarType"
                    label="name"
                    :reduce="name => name.value"
                />
              </div>
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <ListTable
                :tableItems="tableItems"
                :getTaskManagementList="getTaskManagementList"
            />
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import ListTable from '@/components/molecule/company/admin/task-management/ListTable.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleActivity from "@/services/modules/procurement/activity";
import { computed } from 'vue';
import handleChartAccount from '@/services/modules/chartAccount'
import handleContact from '@/services/modules/contact'
import handleDropDowns from '@/services/modules/dropdowns'
import handleProjects from "@/services/modules/procurement/project";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const taskCalendarFilterList = ref([]);
const projects = ref([]);
const taskCalendarType = ref('');
const activityGroup = ref('');
const organizationActivity = ref('');
const client = ref('');
const project = ref('');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
    offset: 20,
});

const token = computed(() => localStorage.getItem('token'));

const { fetchTaskManagementList } = handleActivity()
const { fetchHome } = handleChartAccount()
const { fetchContactProfiles } = handleContact()
const { fetchActivitySetupEndpoint } = handleDropDowns();
const { fetchProjects } = handleProjects()

const onClickToGo = () => {
   getTaskManagementList();
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getTaskManagementList();
}

const getTaskManagementList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchTaskManagementList(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }
        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}&route_name=task-calendar`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if (taskCalendarType.value) query += `&task_calendar_type=${taskCalendarType.value}`;
    if (project.value) query += `&project=${project.value.id}`;
    if (organizationActivity.value) query += `&organization_activity=${organizationActivity.value.id}`;
    if (activityGroup.value) query += `&activity_group=${activityGroup.value.id}`;
    if (client.value) query += `&client=${client.value.id}`;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
    let companyQuery = '?company_id=' + route.params.companyId;
    let projectQuery = companyQuery + '&with_donors=1';

    Promise.all([
        getTaskManagementList(),
        fetchHome().then(res => {
          if (!res.data) {
            return;
          }
          if (res.data && res.data.task_cander_filter){
            taskCalendarFilterList.value = res.data.task_cander_filter;
          }
        }),
        fetchProjects(projectQuery).then(res => {
          if (res.data) {
            projects.value = res.data
          }
        })
    ])
})

</script>
